import React, { memo } from 'react';
import { formGroup, formControl, FormDataType } from '@core/utils/form';
import { CBody } from '@modules/common/CBody';
import { FormColorPicker, FormSelect } from '@core/components/form';
import { WidgetConfirmProps } from '../types';
import { CardTitle } from 'reactstrap';

export function defineStatWithChartWidgetConfigForm() {
  return formGroup({
    color: formControl<string>({ label: 'Line Color', initialValue: '#f1b44c' }),
  });
}

export type StatWithChartWidgetConfigType = ReturnType<typeof defineStatWithChartWidgetConfigForm>;
export type StatWithChartWidgetConfigData = FormDataType<typeof defineStatWithChartWidgetConfigForm>;

export const StatWithChartWidgetConfig = memo((props: WidgetConfirmProps<StatWithChartWidgetConfigType, StatWithChartWidgetConfigData>) => {
  const { form } = props;
  return (
    <CBody>
      <CardTitle>Widget UI Settings</CardTitle>
      <FormColorPicker control={form.controls.color} />
    </CBody>
  );
});
